import {
  BigMaxIcon,
  BigMaxIconMobile,
} from '@kursk/components/ui/icons';
import { useOrientations } from "@common/hooks/useOrientation";
import { getComponentVersion } from "@kursk/utils/componentsTemplates";
import styles from "./MaxIcon.module.scss";

const componentsHash = {
  default: BigMaxIcon,
  v2: BigMaxIcon,
}

const componentsMobileHash = {
  default: BigMaxIconMobile,
  v2: BigMaxIconMobile,
}

const containerStyles = {
  default: styles.iconContainer,
  v2: styles.iconContainerV2
}

const containerMobileStyles = {
  default: styles.iconContainerMobile,
  v2: styles.iconContainerMobileV2
}

export function MaxIconDefault() {
  const orientation = useOrientations();

  const componentVersion = getComponentVersion({ componentType: 'socialCardIconMax' });
  const Component = componentsHash[componentVersion] || componentsHash.default;
  const ComponentMobile = componentsMobileHash[componentVersion] || componentsMobileHash.default;
  const iconContainerClassName = containerStyles[componentVersion] || containerStyles.default;
  const iconContainerMobileClassName = containerMobileStyles[componentVersion] || containerMobileStyles.default;

  return (
    <>
      {orientation === 'desktop' ? (
        <div className={iconContainerClassName}>
          <Component />
        </div>
      ) : (
        <div className={iconContainerMobileClassName}>
          <ComponentMobile />
        </div>
      )}
    </>
  )
}
